import { h } from "@stencil/core";

export interface RenderStylesProps {
    baseClass: string;
    sliderId: string;
    containerWidthXl: string;
    containerWidthL: string;
    containerWidthM: string;
    containerWidthS: string;
    breakpointL: number;
    breakpointM: number;
    breakpointS: number;
    arrowsFollowImg: boolean | string;
    arrowsOffsetTop: number;
    hasOverflowingSlides: boolean;
    handleDuplicatesFlag: boolean;
    noArrows: boolean;
}

export const renderStyles = ({
    baseClass,
    sliderId,
    containerWidthXl,
    containerWidthL,
    containerWidthM,
    containerWidthS,
    breakpointL,
    breakpointM,
    breakpointS,
    arrowsFollowImg,
    arrowsOffsetTop,
    hasOverflowingSlides,
    handleDuplicatesFlag,
    noArrows
}: RenderStylesProps) => {
    const hasCustomWidth =
        containerWidthXl === "100%" && containerWidthL === "100%" && containerWidthM === "100%" && containerWidthS === "100%"
            ? false
            : true;

    return (
        <div>
            {!noArrows && (
                <style>{`
                    @media only screen and (max-width: 567px) {
                        .${baseClass}[slider-id="${sliderId}"] .ux-slider-button-prev,
                        .${baseClass}[slider-id="${sliderId}"] .ux-slider-button-next {
                            display: none;
                        }
                    }
                `}</style>
            )}
            {!handleDuplicatesFlag && (
                <style>
                    {`
                        .${baseClass}[slider-id="${sliderId}"] .ux-slider-slide-duplicate {
                            visibility: hidden;
                        }
                    `}
                </style>
            )}
            {!hasOverflowingSlides && (
                <style>
                    {`
                        .${baseClass}[slider-id="${sliderId}"] .${baseClass}-button-next,
                        .${baseClass}[slider-id="${sliderId}"] .${baseClass}-button-prev,
                        .${baseClass}[slider-id="${sliderId}"] .${baseClass}-pagination {
                            display: none;
                        }
                    `}
                </style>
            )}
            {hasCustomWidth && (
                <style>
                    {`
                        .${baseClass}[slider-id="${sliderId}"] .${baseClass}-container {
                            width: ${containerWidthXl};
                        }
                        @media screen and (max-width: ${breakpointL}px) {
                            .${baseClass}[slider-id="${sliderId}"] .${baseClass}-container {
                                width: ${containerWidthL};
                            }
                        }
                        @media screen and (max-width: ${breakpointM}px) {
                            .${baseClass}[slider-id="${sliderId}"] .${baseClass}-container {
                                width: ${containerWidthM};
                            }
                        }
                        @media screen and (max-width: ${breakpointS}px) {
                            .${baseClass}[slider-id="${sliderId}"] .${baseClass}-container {
                                width: ${containerWidthS};
                            }
                        }
                    `}
                </style>
            )}
            {arrowsFollowImg !== false && (
                <style>{`
                .${baseClass}[slider-id="${sliderId}"] .${baseClass}-button-next,
                .${baseClass}[slider-id="${sliderId}"] .${baseClass}-button-prev
                {
                    top: ${arrowsOffsetTop}px;
                }
                `}</style>
            )}
        </div>
    );
};
